import { enterPresentationMode } from "@/lib/presentation-mode";
import { currentFocusPlanEnv } from "@/lib/focus/focus-natural-size";
import { planArtifactBesideConversation } from "@/lib/focus/focus-plan-companion";
import { usePresentationStore } from "@/stores/presentation-store";
import { useFramesStore } from "@/stores/frames-store";
import { isFrameHiddenByMetadata } from "@/stores/frames-selectors";
import { setFrameHidden } from "@/lib/frame-visibility";
import type { FocusPlacement } from "@/lib/focus/focus-types";

export function presentArtifactBesideConversation(
  conversationFrameId: string,
  artifactFrameId: string,
  { placement }: { placement?: FocusPlacement } = {},
): boolean {
  const artifact = useFramesStore.getState().framesById[artifactFrameId];
  if (!artifact || artifact.frameType === "conversation") return false;

  if (isFrameHiddenByMetadata(artifact)) {
    setFrameHidden(artifactFrameId, false);
  }

  const conversation =
    useFramesStore.getState().framesById[conversationFrameId];
  if (conversation?.frameType !== "conversation") {
    enterPresentationMode("focus", [artifactFrameId], artifactFrameId, {
      allowDesktopMirror: true,
      placement,
    });
    return true;
  }
  if (isFrameHiddenByMetadata(conversation)) {
    setFrameHidden(conversationFrameId, false);
  }

  const { frameIds, customFocusLayout } = planArtifactBesideConversation(
    usePresentationStore.getState().presentation,
    conversationFrameId,
    artifactFrameId,
    currentFocusPlanEnv(),
  );
  enterPresentationMode("focus", frameIds, artifactFrameId, {
    allowDesktopMirror: true,
    placement,
    customFocusLayout,
    preserveMixedFrameTypes: true,
  });
  return true;
}
